import version from '../../package.json';

export const environment = {
  production: true,
  hmr: false,
  version: version.version + '-stage',
  envName: 'stage',
  origins: ['https://payment-stage.archinsurance.com', 'https://billing-portal-stage.archinsurance.io'],
  environmentName: 'STAGE',
  appUrl: 'https://payment-stage.archinsurance.com',
  AIP_AGENCY_ROLE: 'AIGI-ROLE-DIGAIP-AGENCY',
  AIP_ADMIN_ROLE: 'ADMIN',
  aipHostPort: 'http://aigi-drvjbss001:8080/',
  billingPortalApiHost: 'https://payment-stage.archinsurance.com/api/',
  billingPortalConsumerApiHost: 'https://payment-stage.archinsurance.com/api-con/',
  bopQuoteEndPoint: 'api/quote',
  paymentUsIframe: 'https://secure4.paymentus.com/xotp/pm/aidc?authToken=',
  paymentUsOrigin: 'https://secure4.paymentus.com',
  postMessagePmDetailsOrigin: {
    agent: 'https://payment-stage.archinsurance.com/payer-info',
    consumer: 'https://payment-stage.archinsurance.com/direct/payment',
  },
  chaseOrigin: {
    version2: {
      origin: 'https://www.chasepaymentechhostedpay-var.com',
      iframeOrigin: `https://www.chasepaymentechhostedpay-var.com`,
    },
    version3: {
      origin: 'https://chase-var.hostedpaymentservice.net',
      iframeOrigin: `https://chase-var.hostedpaymentservice.net`,
    },
  },

  aipHostPortMenu: 'https://aip-authorization-ms-stage.archinsurance.io/',
  chaseCallBackUrl: 'https://payment-stage.archinsurance.com/success/',
  hostedChaseCallBackUrl: 'https://payment-stage.archinsurance.com/hosted/success/',
  aipHostPortAdmin: 'https://portal-stage.archinsurance.com/aip-admin-api/',
  aipHostPortBase: 'https://portal-stage.archinsurance.com',
  aipHostPort1: 'https://portal-stage.archinsurance.com/aip-base-api/aip-base-api',
  aipHostPort2: 'https://aip-authorization-ms-stage.archinsurance.io',
  pgrRedirectUrl: 'aHR0cHM6Ly9xYS5idXNpbmVzc3F1b3RlLnByb2dyZXNzaXZlY29tbWVyY2lhbC5jb20vYXJjaGNvbmZpcm1hdGlvbg==', //default redirectUrl for Progressive.

  //ROLE
  internal: 'ARCH',
  external: 'AGENCY',
  admin: 'ADMIN',
  internalUser: 'Internal',
  externalUser: 'External',
  INTERNAL_EMAIL_DOMAIN: [
    'archinsurance.com',
    'archgroup.com',
    'archcapservices.com',
    'archgso.com',
    'corp.archcapservices.com',
  ],
  SKIP_PORTALS_INTERNAL_USER: ['AIGI-BasePortal'],
  AUTO_PORTALS_INTERNAL_USER: [{ 'AIGI-BasePortal': 'AIGI-ROLE-DIGAIP-ARCH-UNDERWRITER' }],
  LAUNCHDARKLY_CLIENTID: '638e3c2d3eb0741287501d51',
};
